export function effectiveDiscountPercent(discountType, discountPercent, discountAmount, subtotalBeforeVat) {
  if (discountType === 'percent') return Math.min(100, Math.max(0, Number(discountPercent) || 0));
  if (discountType === 'fixed') {
    const subtotal = Number(subtotalBeforeVat) || 0;
    if (subtotal <= 0) return 0;
    return Math.round(((Number(discountAmount) || 0) / subtotal) * 10000) / 100;
  }
  return 0;
}

export function maxFixedDiscountForCap(subtotalBeforeVat, maxDiscountPercent) {
  const subtotal = Number(subtotalBeforeVat) || 0;
  const cap = Number(maxDiscountPercent);
  if (!Number.isFinite(cap) || subtotal <= 0) return null;
  return Math.round(subtotal * cap) / 100;
}

export function isDiscountWithinCap({
  discountType,
  discountPercent,
  discountAmount,
  subtotalBeforeVat,
  maxDiscountPercent,
  isManager,
}) {
  if (isManager || maxDiscountPercent == null || maxDiscountPercent === '') return true;
  const effective = effectiveDiscountPercent(
    discountType,
    discountPercent,
    discountAmount,
    subtotalBeforeVat,
  );
  return effective <= Number(maxDiscountPercent);
}
